import { render, staticRenderFns } from "./discussRank.vue?vue&type=template&id=49136204&scoped=true&"
import script from "./discussRank.vue?vue&type=script&lang=js&"
export * from "./discussRank.vue?vue&type=script&lang=js&"
import style0 from "./discussRank.vue?vue&type=style&index=0&id=49136204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49136204",
  null
  
)

export default component.exports